/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components */
// Extends From
import Component from '@ember/component';

import { tracked } from '@glimmer/tracking';

// Ember Imports
import { sort, setDiff, alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

// Internal Imports
import Atsi from '@linc-technologies/linced-common/enums/au-atsi';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import NzMoeEthnicity from '@linc-technologies/linced-common/enums/nz-moe-ethnicity';
import PostStatus from '@linc-technologies/linced-common/enums/post-status';
import moment from 'moment';
import { matchYearLevel } from 'linced-app/utils/year-levels';
import { classNames } from '@ember-decorators/component';

@classNames('constrain-md', 'tag-data-filter')
export default class TagDataFilter extends Component {
  // Services
  @service
  session;

  // Constants
  Atsi = Atsi;

  Jurisdiction = Jurisdiction;
  NzMoeEthnicity = NzMoeEthnicity;
  PostStatus = PostStatus;
  matchYearLevel = matchYearLevel;

  // Variables
  @tracked
  openDropdown = false;

  // Params
  allGenders = [];

  allGroups = [];
  allLearners = [];
  allTags = [];
  currentTerm = null;
  dates = null;
  filters = null;
  reset() {}
  setDates() {}
  setFilters() {}
  isLearnerPage = true;
  atsiSortOrder = Object.freeze(['value']);

  @sort('Atsi.values', 'atsiSortOrder')
  allATSI;

  @alias('NzMoeEthnicity.values')
  allEthnicities;

  @alias('session.school.yearLevels')
  rawYearLevels;

  @computed('dates.{endDate,startDate}')
  get activeDateFilter() {
    let startDate = this.get('dates.startDate');
    let endDate = this.get('dates.endDate');
    if (
      startDate.isSame(moment().startOf('day'), 'day') &&
      endDate.isSame(moment().endOf('day'), 'day')
    ) {
      return 'day';
    }
    if (
      startDate.isSame(moment().startOf('week'), 'day') &&
      endDate.isSame(moment().endOf('week'), 'day')
    ) {
      return 'week';
    }
    if (
      startDate.isSame(
        moment(this.get('currentTerm.start')).startOf('day'),
        'day',
      ) &&
      endDate.isSame(moment(this.get('currentTerm.end')).endOf('day'), 'day')
    ) {
      return 'term';
    }
    return '';
  }

  @computed('allTags.[]', 'filters.{includedTags.[],excludedTags.[]}')
  get remainingTags() {
    const allTags = this.allTags;
    const includedTags = this.get('filters.includedTags');
    const excludedTags = this.get('filters.excludedTags');

    return allTags.filter(
      (tag) => !includedTags.includes(tag) && !excludedTags.includes(tag),
    );
  }

  @computed(
    'allLearners.[]',
    'filters.{selectedLearners.[],excludedLearners.[]}',
  )
  get remainingLearners() {
    const allLearners = this.allLearners;
    const selectedLearners = this.get('filters.selectedLearners');
    const excludedLearners = this.get('filters.excludedLearners');

    return allLearners.filter(
      (learner) =>
        !selectedLearners.includes(learner) &&
        !excludedLearners.includes(learner),
    );
  }

  @setDiff('rawYearLevels', 'filters.selectedYearLevels')
  remainingYearLevels;

  @setDiff('allEthnicities', 'filters.selectedEthnicities')
  remainingEthnicities;

  @setDiff('allGroups', 'filters.selectedGroups')
  remainingGroups;

  @setDiff('allATSI', 'filters.selectedATSI')
  remainingATSI;

  @setDiff('allGenders', 'filters.selectedGenders')
  remainingGenders;

  init() {
    super.init(...arguments);
  }

  toggleSelectedItem(arrayString, selectedItem) {
    let array = this.get(`filters.${arrayString}`).slice();
    if (array.includes(selectedItem)) {
      array = array.filter((item) => item !== selectedItem);
    } else {
      array.push(selectedItem);
    }
    this.setFilters(arrayString, array);
  }

  @action
  toggleFilterDropdown() {
    this.openDropdown = !this.openDropdown;
  }

  @action
  toggleFilter(mode, item) {
    this.toggleSelectedItem(mode, item);
  }

  @action
  resetFilters() {
    this.reset();
    let yearLevels = this.yearLevels;
    yearLevels.forEach((yearLevel) => {
      yearLevel.set('active', false);
    });
  }

  @action
  handleSetDates(dateType, date) {
    if (isEmpty(date)) {
      return;
    }
    switch (dateType) {
      case 'startDate':
        this.setDates({
          startDate: moment(date, 'YYYY-MM-DD'),
          endDate: this.dates.endDate,
        });
        break;
      case 'endDate':
        this.setDates({
          startDate: this.dates.startDate,
          endDate: moment(date, 'YYYY-MM-DD'),
        });
        break;
      case 'day':
        this.setDates({
          startDate: moment().startOf('day'),
          endDate: moment().endOf('day'),
        });
        break;
      case 'week':
        this.setDates({
          startDate: moment().startOf('week'),
          endDate: moment().endOf('week'),
        });
        break;
      case 'term':
        this.setDates({
          startDate: moment(this.get('currentTerm.start')).startOf('day'),
          endDate: moment(this.get('currentTerm.end')).endOf('day'),
        });
        break;
    }
  }
}
